import { useEffect } from 'react';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { useTraitsActions } from '@atlassian/jira-traits/src/TraitsStore.tsx';
import { useLinkedTrelloWorkspaceTraitSelector } from './useLinkedTrelloWorkspaceTraitSelector.tsx';

/**
 * Reflects whether a site was created via the Trello -> Jira cross flow program.
 *
 * This status is stored in a TAP trait, jira_workmanagement_linked_trello_workspace,
 * evaluated via @atlassian/jira-traits.
 *
 * @see {@link https://hello.atlassian.net/wiki/spaces/PMXF/overview?homepageId=2833886238}
 * @see {@link https://data-portal.internal.atlassian.com/targeting/traits/d9ebfbaa-3928-40fd-bf75-af5ebf9f74e2}
 *
 * @returns boolean reflecting the value of the jira_workmanagement_linked_trello_workspace trait
 */
export const useIsTrelloCrossflowEnabled = (): boolean => {
	const cloudId = useCloudId();
	const { fetchTraits } = useTraitsActions();

	useEffect(() => {
		fetchTraits(['SITE'], { cloudId });
	}, [fetchTraits, cloudId]);

	const [isTrelloWorkspaceLinked] = useLinkedTrelloWorkspaceTraitSelector();
	return isTrelloWorkspaceLinked;
};
